import { isArray } from 'lodash';
import Poi from '@/api/poi';
import Contract from '@/api/contract';
import Merchant from '@/api/merchant';
import STATUS from '@/constants/status';


const State = {
  loading: false, // 全屏loading
  isAgent: false, // 代理商商家
  hasCommisionViewAuth: false, // 展示佣金权限
  poiList: [],
  poiPage: {
    pageNum: 1,
    pageCount: 1,
  },
  repairInfoList: [], // 活动补款数据
  urlPid: '', // 参数pid传入，需设置该pid为当前poiId
  kdbPoiId: '', // 开店宝poiId
  currentPoi: {
    poiId: 0, // 门店id
    poiName: '', // 门店名称
    poiSource: 0, // 门店来源：1-运营平台、2-上单系统
    poiStatus: 0, // 门店的商家入驻状态：1-已签约、2-已开通、3-已解约
    signTime: '', // 运营平台签约时间yyyy-mm-dd格式，合作信息页面使用
  },
  searchPois: [],
  signFlag: false, // 所有门店是否确认签约,
  isAllPois: true, // 是否切换为全部门店
  profitMonth: '', // 我的收益 月份
  /**
   * 签约信息
   * [{
   *     benefitRate: 6, // 分成比例
   *     cabinetCount: 10, // 机柜数量
   *     collaborationId: 10001, // 合作信息Id
   *     invoiceDesc: "贵司需就打款分成金额为美团开具税率为6%、发票科目为“服务费”的增值税专用发票。", // 发票说明
   *     payDesc: "每次签约机柜分开打款，按照当前签约信息中机柜收益总额打款",  // 打款说明
   *     poiId: 86958, // 门店ID
   *     poiName: "一棵树", // 门店名称
   *     powerbankCount: 40, // 充电宝数量
   *     walletId: 178362, // 钱袋宝账号
   *     signTime: "2020-2-1 15:45:56", // 签约时间yyyy-MM-dd HH:mm:ss格式
   *     type: 1, // 合同类型  0：新签合同，1：机柜增减
   * }]
   */
  signInfo: [],
  signInfoHasNext: false,
  bizlogintoken: '', // 开店宝token
  accountType: -1, // 账号类型 0 普通商家 1 点评商家 2 第三方 3 代理商 -1 未获取
  adminAccount: null,
};

const getters = {
  isMerchantUser(state) {
    return state.accountType === 0;
  },
  isThirdPartyUser(state) {
    return state.accountType === 2;
  },
  isAgentUser(state) {
    return state.accountType === 3;
  },
  isMerchantOrThirdPartyUser(state) {
    return state.accountType === 0 || state.accountType === 2;
  },
  isAgentPoi(state) {
    return function (poiId) {
      poiId = Number(poiId);
      const pois = state.poiList.filter((item) => item.poiId === poiId);
      if (pois.length) {
        return pois[0].type === 3;
      } else {
        return undefined;
      }
    };
  },
  poiForWallet(state) {
    return state.poiList[0] ? (state.poiList[0].poiId || state.poiList[1].poiId) : 0;
  },
  hasSignInfo(state) {
    return state.signInfo.length;// || state.signInfoHasNext;
  },
};

const mutations = {
  setLoading(state, data = true) {
    state.loading = data;
  },
  setPoiList(state, data = []) {
    if (isArray(data)) {
      state.poiList = state.poiList.concat(data);
    }
  },
  setCurrentPoi(state, data = {}) {
    state.currentPoi = data;
  },
  setAllPois(state, data = {}) {
    state.isAllPois = data;
  },
  setProfitMonth(state, data = {}) {
    state.profitMonth = data;
  },
  setUrlPid(state, id) {
    state.urlPid = id;
  },
  setKdbPoiId(state, id) {
    state.kdbPoiId = id;
  },
  setIsAgent(state, data) {
    state.isAgent = data;
  },
  setHasCommisionViewAuth(state, data) {
    state.hasCommisionViewAuth = data;
  },
  /**
   * 通过poiId设置当前poi信息
   * @param state
   * @param id
   */
  setCurrentPoiById(state, id) {
    if (!state.poiList.length) {
      return;
    }
    if (!id) {
      state.currentPoi = state.poiList[0];
      return;
    }
    for (let i = 0, l = state.poiList.length; i < l; ++i) {
      if (state.poiList[i].poiId === parseInt(id, 0)) {
        state.currentPoi = state.poiList[i];
        return;
      }
    }
    if (state.poiList[0]) {
      state.currentPoi = state.poiList[0];
    }
  },
  setSignFlag(state, data = true) {
    state.signFlag = data;
  },
  setRepairInfoList(state, data) {
    state.repairInfoList = data;
  },
  setSignInfo(state, data) {
    state.signInfo = data;
  },
  setSignInfoHasNext(state, data) {
    state.signInfoHasNext = data;
  },
  setBizlogintoken(state, data) {
    state.bizlogintoken = data;
  },
  setAccountType(state, data) {
    state.accountType = data;
  },
  setAdminAccount(state, data) {
    state.adminAccount = data;
  },
  setPoiPage(state, data) {
    state.poiPage = data;
  },
  setSearchPois(state, data) {
    state.searchPois = data;
  },
  setPoiLoading(state, data = true) {
    state.poiPage.loading = data;
  },
};

const actions = {
  /**
   * 获取poiList数据
   * 设置当前poi为list[0]
   * @param state
   * @param commit
   * @returns {Promise.<TResult>}
   */
  fetchPoiData: async ({ state, commit }) => {
    commit('setPoiLoading');
    if (state.poiPage.pageNum > state.poiPage.pageCount) {
      return;
    }

    const { data } = await Poi.getPois(state.poiPage.pageNum, 20);
    commit('setPoiPage', {
      pageCount: data.pageCount,
      pageNum: data.pageNum + 1,
      loading: false,

    });
    commit('setPoiList', data.content);
    if (!state.currentPoi.id) {
      commit('setCurrentPoiById', '');
    }
  },
  /**
   * 获取待签约信息
   * !poiId（没有门店） || poiSource = 1 || poiStatus = 3的情况，不用获取
   * @param state
   * @param commit
   * @returns {Promise.<TResult>}
   */
  fetchNotSignContracts: async ({ state, commit }, payload) => {
    if (state.signFlag && !payload) {
      return Promise.resolve();
    }
    return Contract.getUnSignContractNew({
      accountType: state.accountType,
      ...payload, // 合并传入的参数
    })
      .then((res) => {
        if (res.code === STATUS.SUCCESS && res.data) {
          const computedSignInfo = res.data.contractInfoList || [];
          if (!payload) { // 首页请求的才commit，notsign默认走自己的逻辑
            commit('setSignInfo', computedSignInfo);
            commit('setSignInfoHasNext', res.data.hasNext);
          }
          if (!computedSignInfo.length) {
            commit('setSignFlag');
          }
          return Promise.resolve(res.data);
        }
        return Promise.reject(new Error(JSON.stringify({ code: res.respCode, path: 'fetchNotSignContracts' })));
      })
      .catch((err) => Promise.reject(err));
  },
  /**
   * 获取账号类型
   * @param state
   * @param commit
   * @returns {Promise.<TResult>}
   */
  fetchAccountType: async ({ state, commit }) => {
    if (state.accountType !== -1) {
      return Promise.resolve();
    }
    return Merchant.getAccountType()
      .then((res) => {
        if (res.respCode === STATUS.SUCCESS && res.data) {
          commit('setAccountType', res.data.accountType);
          return Promise.resolve();
        }
        return Promise.reject(new Error(JSON.stringify({ code: res.respCode, path: 'fetchAccounType' })));
      })
      .catch((err) => Promise.reject(err));
  },
  /**
   * 是否登陆了正确的超管账号
   */
  fetchAdminAccount: async ({ state, commit }) => {
    if (state.adminAccount !== null) {
      return Promise.resolve();
    }
    return Merchant.getAdminAccount()
      .then((res) => {
        const { code, data } = res;
        if (code === STATUS.SUCCESS || code === STATUS.ADMIN_ACCOUNT_ERROR) {
          const success = res.code === STATUS.SUCCESS;
          commit('setAdminAccount', { ...data, success });
          return Promise.resolve();
        }
        return Promise.reject(new Error(JSON.stringify({ code, path: 'fetchAdminAccount' })));
      })
      .catch((err) => Promise.reject(err));
  },
  haveProxyPoi: async ({ commit }) => Poi.haveProxyPoi().then((res) => {
    const { data, error } = res;
    if (error) {
      return Promise.reject(JSON.stringify({ code: error, path: 'haveProxyPoi' }));
    } else {
      commit('setIsAgent', data);
      return Promise.resolve();
    }
  }),

};

export default {
  state: State,
  getters,
  mutations,
  actions,
};
